import { FileCheck } from "react-bootstrap-icons";
import { House, FiletypePdf, Search,Cart,FileEarmarkPlus} from "react-bootstrap-icons";

const options =[
    // {
    //     variant: 'divider',
    //     label: 'Administrador',
    //     roles: ['administrator','recepcion']
    // },
    {
        label :"Carrito",
        defaultOption: false,
        icon : <Cart />,
        route : '/Carrito',
    },
    {
        label :"Expediente",
        defaultOption: false,
        icon : <FileEarmarkPlus />,
        route : '/Expediente',
    }
    // {
    //     variant: 'divider',
    //     label: 'Cierres Bancarios',
    //     roles: ['cierre-bancario','administrator','recepcion']
    // },
    // {
    //     label: "Carga de estado de cuenta",
    //     defaultOption: false,
    //     icon: <ArrowBarDown />,
    //     route: '/cierres/carga-estado-cuenta',
    //     alias:[
    //     ],
    //     roles: ['recepcion','administrator']
    // },
    // {
    //     label :"Carga de documentos",
    //     defaultOption: false,
    //     icon : <ArrowBarDown />,
    //     route : '/cierres/carga-documentos-cierre',
    //     alias : [
    //     ],
    //     roles: ['cierre-bancario','administrator','recepcion']
    // },
    // {
    //     variant: 'divider',
    //     label: 'Libros Contables',
    //     roles: ['libros-contables','administrator','recepcion']
    // },
    // {
    //     label: "Carga de lote",
    //     defaultOption: false,
    //     icon: <ArrowBarDown />,
    //     route: '/libros/carga-lote',
    //     alias:[
    //     ],
    //     roles: ['libros-contables','administrator','recepcion']
    // },
    // {
    //     label :"Carga individual",
    //     defaultOption: false,
    //     icon : <ArrowBarDown />,
    //     route : '/libros/carga-individual',
    //     alias : [
    //     ],
    //     roles: ['libros-contables','administrator','recepcion']
    // },
    // {
    //     variant: 'divider',
    //     label: 'Notas de debito',
    //     roles: ['notas-debito','administrator','recepcion']
    // },
    // {
    //     label :"Carga en Lote",
    //     defaultOption: false,
    //     icon : <ArrowBarDown />,
    //     route : '/notas/carga-documentos-notas',
    //     alias : [
    //     ],
    //     roles: ['notas-debito','administrator','recepcion']
    // },
    // {
    //     variant: 'divider',
    //     label: 'Conciliaciones',
    //     roles: ['conciliacion','administrator','recepcion']
    // },
    // {
    //     label :"Carga en Lote",
    //     defaultOption: false,
    //     icon : <ArrowBarDown />,
    //     route : '/conciliaciones/carga-documentos-conciliaciones',
    //     alias : [
    //     ],
    //     roles: ['conciliacion','administrator','recepcion']
    // },
];
export default options;